
/* Single image */
import simg1 from '../images/service-single/1.jpg'
import simg2 from '../images/service-single/2.jpg'
import simg3 from '../images/service-single/3.jpg'
import simg4 from '../images/service-single/4.jpg'
import simg5 from '../images/service-single/5.jpg'
import simg6 from '../images/service-single/6.jpg'
import { API_CONFIG, getDefaultHeaders } from '../config/api';

// API function to fetch categories
export const fetchCategories = async () => {
  try {
    const response = await fetch(`${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.CATEGORIES}`, {
      method: 'GET',
      headers: getDefaultHeaders(),
      timeout: API_CONFIG.TIMEOUT,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching categories:', error);
    return null;
  }
};

// API function to fetch all visible categories (for services page)
export const fetchAllCategories = async () => {
  try {
    const response = await fetch(`${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.ALL_CATEGORIES}`, {
      method: 'GET',
      headers: getDefaultHeaders(),
      timeout: API_CONFIG.TIMEOUT,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching all categories:', error);
    return null;
  }
};



const Services = [
  {
    id: 1,
    icon: "flaticon-microsurgery",
    simage: simg1,
    title: "Cirugía plástica",
    description:
      "Reconstruimos o mejoramos la función y apariencia del cuerpo, abarcando procedimientos reparadores y estéticos.",
    slug: "Cirugia-Plastica",
  },
  {
    id: 2,
    icon: "flaticon-mortar",
    simage: simg2,
    title: "Otorrinolaringología",
    description:
      "Diagnosticamos y tratamos quirúrgicamente afecciones de oídos, nariz, garganta, y estructuras relacionadas de cabeza y cuello.",
    slug: "Otorrinolaringologia",
  },
  {
    id: 3,
    icon: "flaticon-bone",
    simage: simg3,
    title: "Oncología",
    description:
      "Nos dedicamos al diagnóstico y tratamiento del cáncer. En oncología quirúrgica, extirpamos tumores.",
    slug: "Oncología",
  },
  {
    id: 4,
    icon: "flaticon-baby",
    simage: simg4,
    title: "Cardiología",
    description:
      "Estudiamos y tratamos enfermedades del corazón y sistema circulatorio. Evaluamos y damos seguimiento a pacientes para cirugía cardiovascular.",
    slug: "Cardiología",
  },
  {
    id: 5,
    icon: "flaticon-rehabilitation",
    simage: simg5,
    title: "Fisioterapia",
    description:
      "Ayudamos a recuperar la movilidad y función corporal tras lesiones o cirugías. Somos clave en la rehabilitación postoperatoria.",
    slug: "Fisioterapia",
  },
  {
    id: 6,
    icon: "flaticon-microsurgery",
    simage: simg6,
    title: "Urología",
    description:
      "Tratamos enfermedades del sistema urinario (hombres y mujeres) y del sistema reproductivo masculino, a menudo con cirugía.",
    slug: "Urología",
  },
  {
    id: 7,
    icon: "flaticon-",
    simage: simg1,
    title: "Ginecología",
    description:
      "Nos ocupamos de la salud del sistema reproductor femenino, incluyendo el manejo quirúrgico de patologías ginecológicas.",
    slug: "Ginecologia",
  },
  {
    id: 8,
    icon: "flaticon-tooth",
    simage: simg2,
    title: "Odontología",
    description:
      "General y estética, tratamientos faciales / corporales y odontología especializada.",
    slug: "Odontología",
  },
  {
    id: 9,
    icon: "flaticon-ambulance",
    simage: simg3,
    title: "Gastroenterología",
    description:
      "Estudiamos y tratamos trastornos del sistema digestivo. Podemos realizar procedimientos endoscópicos o cirugías digestivas.",
    slug: "Gastroenterología",
  },
  {
    id: 10,
    icon: "flaticon-ambulance",
    simage: simg4,
    title: "Traumatología",
    description:
      "Nos especializamos en el diagnóstico y tratamiento de lesiones del sistema musculoesquelético (huesos, articulaciones, ligamentos), frecuentemente con cirugía.",
    slug: "Traumatología",
  },
];
export default Services;